import { Pipe, PipeTransform } from '@angular/core';
import { Reservation } from 'src/app/models/booking/reservation.interface';

@Pipe({
  name: 'sumRegistrationPrices'
})
export class SumRegistrationPricesPipe implements PipeTransform {

  transform(reservations: Reservation[]): number {
    if (!reservations?.length) {
      return 0;
    }

    const prices = reservations.map(({registrations}) => registrations.map((reg) => reg.zi.price)).flat();
    return prices.reduce((s, summand) => s + summand, 0.0);
  }
}
